import styles from "./helpPage.module.scss";
import Layout from "components/layout/Layout";
import HelpfulBeaver from 'assets/images/helpfulBeaver.svg';
import { DropDownTextBlock } from "components/dropDownTextBlock/dropDownTextBlock";
import SettingsButtonBlue from "components/icons/settingsButtonBlue";
import { Button } from "components/UI/button/button";
import React, { useState } from 'react';
import confetti from 'canvas-confetti';
import { Client, getClientById } from "actions/clientActions";
import { useGetCompanies } from "actions/companyActions";
import { sendMail } from "actions/userActions";
import {useGetUser} from "actions/userActions";
import translations from "locales";

export const HelpPage = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [issueDetails, setIssueDetails] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isErrored, setIsErrored] = useState(false);
  const lang = localStorage.getItem('lang') || 'en';
  const currentUser = useGetUser();
  const userName = currentUser.data?.firstName;
  
  const {
    data: companyData,
  } = useGetCompanies({
    rowNumber: 100,
  });
  const firstClNo = companyData?.[0]?.clNo;

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    try {
      const response = await sendMail({
        subject: `IT Help Request: ${userName} - ${firstClNo}`,
        body: `${issueDetails}</br></br><strong>${phoneNumber}</strong>`,
        emails: 'it@gands.com',
        attachments: null,
      });
    
    } catch (error) {
      setIsErrored(true);
     
    }
    finally{
      setIsSubmitted(true);
      setPhoneNumber('');
      setIssueDetails('');
      confetti({
        particleCount: 200,
        spread: 350,
        origin: { y: 0.6 },
      });
    }

  };
  return (
    <Layout>
      <div className={styles.HelpPageHeader}>
        <div>
          <h2 className={styles.helpPageTitle}>{lang === 'fr' ? translations.fr.how_can_we_help_you : translations.en.how_can_we_help_you}</h2>
          <p>{lang === 'fr' ? translations.fr.faqs_intro : translations.en.faqs_intro}</p>
          <p>{lang === 'fr' ? translations.fr.tech_question_contact : translations.en.tech_question_contact} <a className={styles.boldBlue}>IT@gands.com</a>.</p>
          <p>{lang === 'fr' ? translations.fr.case_specific_contact : translations.en.case_specific_contact}</p>
        </div>
        <div className={styles.imageContainer}>
          <img className={styles.helpfulBeaver} src={HelpfulBeaver} alt="Helpful Beaver" />
        </div>
      </div>
      <div className={styles.HelpPageWrapper}>
        <div className={styles.HelpPageKnowledgeBlocks}>
          <DropDownTextBlock 
            title={lang === 'fr' ? translations.fr.i_need_tech_support : translations.en.i_need_tech_support}
            dropDownClassName={styles.DropDownTextBlock}
            defaultOpen={true}
          >
            <div>
              <p>{lang === 'fr' ? translations.fr.tech_issue_instructions : translations.en.tech_issue_instructions}</p>
              <p>{lang === 'fr' ? translations.fr.it_team_contact : translations.en.it_team_contact}</p>
              <input 
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                placeholder={lang === 'fr' ? translations.fr.phone : translations.en.phone} 
                className={`${styles.phoneTextBox} ${isSubmitted ? styles.phoneTextBoxSubmitted : ''}`}
                readOnly={isSubmitted}
                maxLength={15}
              />
              <textarea 
                value={issueDetails}
                onChange={(e) => setIssueDetails(e.target.value)}
                placeholder={lang === 'fr' ? translations.fr.provide_issue_details : translations.en.provide_issue_details}
                rows={4}
                className={`${styles.issueTextBox} ${isSubmitted ? styles.issueTextBoxSubmitted : ''}`}
                readOnly={isSubmitted}
                maxLength={300}
              />
              <div className={styles.buttonDiv}>
                <Button className={styles.submitButton} type="submit"  onClick={handleSubmit} disabled={isSubmitted}>{lang === 'fr' ? translations.fr.submit : translations.en.submit}</Button>
              </div>
              {isSubmitted && isErrored == false && (
                <div className={styles.submissionMessage}>
                  <p>Thank you for your submission! A member of our IT team will get in touch with you shortly. ✔️</p>
                </div>
              )}
              {isErrored && (
                <div className={styles.submissionMessage}>
                  <p>There was an error processing your request, please contact it@gands.com directly for assistance.</p>
                </div>
              )}
            </div>
          </DropDownTextBlock>
          <DropDownTextBlock 
            title={lang === 'fr' ? translations.fr.how_to_reset_password : translations.en.how_to_reset_password}
            dropDownClassName={styles.DropDownTextBlock}
          >
            <div>
              <p>{lang === 'fr' ? translations.fr.reset_password_instructions : translations.en.reset_password_instructions}</p>
              {lang === 'fr' ? (
                <ol>
                  <li>Allez dans <a className={styles.boldBlack}>Paramètres</a> (cliquez sur l’icône
                    <span className={styles.settingsIconPlaceholder}><SettingsButtonBlue/></span>
                        en haut à droite).
                  </li>
                  <li>Cliquez sur l’onglet <a className={styles.boldBlack}>Réinitialiser le mot de passe</a>.</li>
                  <li>{translations.fr.enter_passwords_note}</li>
                  <li>Cliquez sur <a className={styles.boldBlack}>Enregistrer le mot de passe</a>.</li>
                </ol>
              ) : (
                <ol>
                  <li>Go to <a className={styles.boldBlack}>Settings</a> (click the
                    <span className={styles.settingsIconPlaceholder}><SettingsButtonBlue/></span>
                        icon on the top right corner).
                  </li>
                  <li>Click on the <a className={styles.boldBlack}>Reset Password</a> tab.</li>
                  <li>{translations.en.enter_passwords_note}</li>
                  <li>Click <a className={styles.boldBlack}>Save Password</a>.</li>
                </ol>
              )}
            </div>
          </DropDownTextBlock>
          <DropDownTextBlock 
            title={lang === 'fr' ? translations.fr.accepted_file_formats : translations.en.accepted_file_formats}  
            dropDownClassName={styles.DropDownTextBlock}
          >
            <div>
              <p>{lang === 'fr' ? translations.fr.accepted_file_formats_list : translations.en.accepted_file_formats_list}</p>
              <p>{lang === 'fr' ? translations.fr.no_zipped_files : translations.en.no_zipped_files}</p>
            </div>
          </DropDownTextBlock>
          <DropDownTextBlock 
            title={lang === 'fr' ? translations.fr.how_to_pay_consultation : translations.en.how_to_pay_consultation}
            dropDownClassName={styles.DropDownTextBlock}
          >
            <div>
              <p>{lang === 'fr' ? translations.fr.consultation_payment_url : translations.en.consultation_payment_url}&nbsp; 
                <a className={styles.boldBlue} href="https://www.gands.com/consultation-payment/" target="_blank" rel="noopener noreferrer">
                  https://www.gands.com/consultation-payment/
                </a>
              </p>
              <p>{lang === 'fr' ? translations.fr.no_amex_payment : translations.en.no_amex_payment}</p>
            </div>
          </DropDownTextBlock>
          <DropDownTextBlock 
            title={lang === 'fr' ? translations.fr.how_to_pay_invoice : translations.en.how_to_pay_invoice}
            dropDownClassName={styles.DropDownTextBlock}
          >
            <div>
              <p>{lang === 'fr' ? translations.fr.invoice_payment_note : translations.en.invoice_payment_note}</p>
              <ul>
                <li>{lang === 'fr' ? translations.fr.invoice_payment_cad_url : translations.en.invoice_payment_cad_url}&nbsp; 
                  <a className={styles.boldBlue} href="https://www.gands.com/invoice-payment-cad/" target="_blank" rel="noopener noreferrer">
                    https://www.gands.com/invoice-payment-cad/
                  </a>
                </li>
                <li>{lang === 'fr' ? translations.fr.invoice_payment_usd_url : translations.en.invoice_payment_usd_url}&nbsp; 
                  <a className={styles.boldBlue} href="https://www.gands.com/invoice-payment-usd/" target="_blank" rel="noopener noreferrer">
                    https://www.gands.com/invoice-payment-usd/
                  </a>
                </li>
              </ul>
            </div>
          </DropDownTextBlock>
          <DropDownTextBlock 
            title={lang === 'fr' ? translations.fr.application_time_question : translations.en.application_time_question}
            dropDownClassName={styles.DropDownTextBlock}
          >
            <div>
              <p>{lang === 'fr' ? translations.fr.application_time_answer : translations.en.application_time_answer}</p>
              <p>{lang === 'fr' ? translations.fr.processing_time_url : translations.en.processing_time_url}&nbsp; 
                <a className={styles.boldBlue} href="https://www.canada.ca/en/immigration-refugees-citizenship/services/application/check-processing-times.html" target="_blank" rel="noopener noreferrer">
                  https://www.canada.ca/en/immigration-refugees-citizenship/services/application/check-processing-times.html
                </a>
              </p>
              <p>{lang === 'fr' ? translations.fr.check_status_url : translations.en.check_status_url}&nbsp; 
                <a className={styles.boldBlue} href="https://www.canada.ca/en/immigration-refugees-citizenship/services/application/check-status.html" target="_blank" rel="noopener noreferrer">
                  https://www.canada.ca/en/immigration-refugees-citizenship/services/application/check-status.html
                </a>
              </p>
            </div>
          </DropDownTextBlock>
        </div>
      </div>
    </Layout>
  );
};
